// UI strings per language. `en` is the canonical fallback.

export const translations = {
  en: {
    nav: {
      about: "About",
      experience: "Experience",
      education: "Education",
      projects: "Projects",
      contact: "Contact",
      resume: "Resume",
    },
    hero: {
      eyebrow: "Software · Backend · DevOps · AI",
      greeting: "Hi there, I'm",
      name: "Mehdi Ben Hariz.",
      bio:
        "I turn ideas into production systems — clean backends, smooth pipelines, and a touch of AI magic. From first commit to final deploy, I build software that ships.",
      ctaWork: "Explore my work",
      ctaContact: "Get in touch",
      trackRecord: "Track record",
      scroll: "Scroll",
      stats: [
        { strong: "Various freelance projects", soft: "Development · Implementation · Consulting" },
        { strong: "Backend / AI Engineer", soft: "CI-HUB · backend & AI projects" },
        { strong: "Backend / DevOps Engineer", soft: "C4SAM · DevSecOps tools integration" },
        { strong: "International experience", soft: "Tunisia · France · USA (UW-Stout scholar)" },
      ],
    },
    about: {
      eyebrow: "What I do",
      title: "What I do.",
      lead: "A software engineer passionate about solving real-world problems and building efficient solutions.",
      points: [
        "Lead the development of a product from scratch to production",
        "Implement DevOps practices and pipelines to automate tasks",
        "Integrate AI modules to enhance user experience and optimize processes",
      ],
    },
    xp: {
      eyebrow: "Career",
      title: "Where I've worked.",
      lead: "From backend development to DevOps consulting and AI engineering — across agencies, enterprises, and research labs.",
      groups: {
        pro: "Professional experience",
        internships: "Internships",
        community: "Community & leadership",
      },
    },
    edu: {
      eyebrow: "Education",
      title: "My journey.",
      lead: "From preparatory classes in Sousse to an exchange year in the USA.",
    },
    projects: {
      eyebrow: "Selected work",
      title: "Things I've built.",
      lead: "A mix of production apps, DevOps infrastructure, and side projects.",
      live: "Live",
      code: "Code",
    },
    contact: {
      eyebrow: "Get in touch",
      title: "Need a backend, DevOps, or AI engineer who delivers? Let's talk.",
      ctaContact: "Contact me",
      ctaResume: "Download resume",
      footer: "Built with React",
    },
  },

  fr: {
    nav: {
      about: "À propos",
      experience: "Expérience",
      education: "Formation",
      projects: "Projets",
      contact: "Contact",
      resume: "CV",
    },
    hero: {
      eyebrow: "Logiciel · Backend · DevOps · IA",
      greeting: "Salut, moi c'est",
      name: "Mehdi Ben Hariz.",
      bio:
        "Je transforme les idées en systèmes de production — des backends propres, des pipelines fluides et une touche d'IA. Du premier commit au déploiement final, je construis des logiciels qui tournent.",
      ctaWork: "Découvrir mes projets",
      ctaContact: "Me contacter",
      trackRecord: "Palmarès",
      scroll: "Défiler",
      stats: [
        { strong: "Divers projets freelance", soft: "Développement · Implémentation · Conseil" },
        { strong: "Ingénieur Backend / IA", soft: "CI-HUB · projets backend & IA" },
        { strong: "Ingénieur Backend / DevOps", soft: "C4SAM · intégration d'outils DevSecOps" },
        { strong: "Expérience internationale", soft: "Tunisie · France · USA (boursier UW-Stout)" },
      ],
    },
    about: {
      eyebrow: "Ce que je fais",
      title: "Ce que je fais.",
      lead: "Ingénieur logiciel passionné par la résolution de problèmes concrets et la création de solutions efficaces.",
      points: [
        "Piloter le développement d'un produit de zéro jusqu'à la production",
        "Mettre en place des pratiques et pipelines DevOps pour automatiser les tâches",
        "Intégrer des modules d'IA pour améliorer l'expérience utilisateur et optimiser les processus",
      ],
    },
    xp: {
      eyebrow: "Parcours",
      title: "Mes expériences.",
      lead: "Du développement backend au consulting DevOps et à l'ingénierie IA — agences, grandes entreprises et laboratoires de recherche.",
      groups: {
        pro: "Expérience professionnelle",
        internships: "Stages",
        community: "Communauté & leadership",
      },
    },
    edu: {
      eyebrow: "Formation",
      title: "Mon parcours.",
      lead: "Des classes préparatoires à Sousse jusqu'à une année d'échange aux États-Unis.",
    },
    projects: {
      eyebrow: "Projets choisis",
      title: "Ce que j'ai construit.",
      lead: "Un mélange d'applications en production, d'infrastructure DevOps et de projets personnels.",
      live: "Démo",
      code: "Code",
    },
    contact: {
      eyebrow: "Entrer en contact",
      title: "Besoin d'un ingénieur backend, DevOps ou IA qui livre ? Parlons-en.",
      ctaContact: "Me contacter",
      ctaResume: "Télécharger le CV",
      footer: "Créé avec React",
    },
  },

  ar: {
    nav: {
      about: "نبذة",
      experience: "الخبرة",
      education: "التعليم",
      projects: "المشاريع",
      contact: "تواصل",
      resume: "السيرة",
    },
    hero: {
      eyebrow: "برمجيات · باك إند · DevOps · ذكاء اصطناعي",
      greeting: "مرحباً، أنا",
      name: "مهدي بن حريز.",
      bio:
        "أحوّل الأفكار إلى أنظمة جاهزة للإنتاج — باك إند نظيف، وخطوط نشر سلسة، ولمسة من الذكاء الاصطناعي. من أول سطر برمجي إلى الإطلاق النهائي، أبني برمجيات تُنجَز وتُسلَّم.",
      ctaWork: "استكشف أعمالي",
      ctaContact: "تواصل معي",
      trackRecord: "سجل الإنجازات",
      scroll: "مرّر",
      stats: [
        { strong: "مشاريع مستقلة متنوعة", soft: "تطوير · تنفيذ · استشارات" },
        { strong: "مهندس باك-إند / ذكاء اصطناعي", soft: "CI-HUB · مشاريع باك-إند وذكاء اصطناعي" },
        { strong: "مهندس باك-إند / DevOps", soft: "C4SAM · تكامل أدوات DevSecOps" },
        { strong: "خبرة دولية", soft: "تونس · فرنسا · الولايات المتحدة (حامل منحة UW-Stout)" },
      ],
    },
    about: {
      eyebrow: "ما أقوم به",
      title: "ما أقوم به.",
      lead: "مهندس برمجيات شغوف بحل المشكلات الواقعية وبناء حلول فعّالة.",
      points: [
        "قيادة تطوير المنتج من الصفر حتى الإنتاج",
        "تطبيق ممارسات DevOps وبناء خطوط أتمتة للمهام",
        "دمج وحدات الذكاء الاصطناعي لتحسين تجربة المستخدم والعمليات",
      ],
    },
    xp: {
      eyebrow: "المسار المهني",
      title: "أين عملت.",
      lead: "من تطوير الباك-إند إلى استشارات DevOps وهندسة الذكاء الاصطناعي — عبر وكالات وشركات كبرى ومختبرات بحثية.",
      groups: {
        pro: "الخبرة المهنية",
        internships: "التدريبات",
        community: "المجتمع والقيادة",
      },
    },
    edu: {
      eyebrow: "التعليم",
      title: "مسيرتي الدراسية.",
      lead: "من الأقسام التحضيرية في سوسة إلى سنة تبادل في الولايات المتحدة.",
    },
    projects: {
      eyebrow: "أعمال مختارة",
      title: "ما قمت ببنائه.",
      lead: "مزيج من تطبيقات الإنتاج وبنية DevOps التحتية ومشاريع جانبية.",
      live: "مباشر",
      code: "الكود",
    },
    contact: {
      eyebrow: "تواصل معي",
      title: "تحتاج مهندس باك-إند أو DevOps أو ذكاء اصطناعي يُنجز فعلًا؟ لنتحدث.",
      ctaContact: "تواصل معي",
      ctaResume: "تحميل السيرة الذاتية",
      footer: "صُنع بـ React",
    },
  },
};

// Per-item overrides for data coming from portfolio.js.
// Keyed by company name (roles/descs) or degree name (edu).
export const itemTranslations = {
  fr: {
    roles: {
      "Astrolab Agency": "Développeur Backend",
      "Dassault Systèmes": "Ingénieur Logiciel & Data Science (Stagiaire)",
      C4SAM: "Ingénieur Backend / DevOps (Consultant)",
      "CI-HUB": "Ingénieur Backend / IA",
      ARSII: "Stagiaire Développement Mobile",
      Capgemini: "Assistant Consultant",
      "Proxym-group": "Stagiaire Développement Web",
      "UW-Stout": "Stagiaire de Recherche",
      "Microsoft Issatso Club": "Président",
      "CyberTrace Club": "Membre de l'équipe Dev",
    },
    descs: {
      "Astrolab Agency": "Je participe au cycle de développement de solutions logicielles avec NestJS.",
      "Dassault Systèmes":
        "Responsable de la mise en place d'une solution d'ingestion et d'analyse de logs avec Java, Python et Grafana.",
      C4SAM: "Responsable de l'implémentation et de la maintenance d'un produit d'intégration d'outils DevSecOps.",
      "CI-HUB": "Responsable du développement et de la maintenance des projets backend et IA de l'entreprise.",
      ARSII: "Participation à la conception, au prototypage, à l'implémentation et au déploiement d'une application mobile multiplateforme.",
      Capgemini:
        "Membre du programme de la communauté des architectes. Découverte et test d'outils DevOps sous la supervision d'un architecte de l'entreprise.",
      "Proxym-group":
        "Implémentation du concept maker-checker dans une application web pour les services financiers avec .NET et React.",
      "UW-Stout":
        "Travail sur les bases de données NoSQL, comparaison de différents cas d'usage, avec présentation des résultats au Research Day.",
      "Microsoft Issatso Club":
        "Direction et développement du club à travers plusieurs rôles et responsabilités. Membre actif depuis la fondation du club en 2019.",
      "CyberTrace Club": "Participation au développement d'une application web pour le club en tant que développeur backend.",
    },
    edu: {
      "Integrated Preparatory Cycle": {
        subHeader: "Cycle Préparatoire Intégré",
        desc: "Mathématiques, physique et informatique.",
        bullets: ["Major de promotion"],
      },
      "Software Engineering degree": {
        subHeader: "Diplôme d'Ingénieur en Génie Logiciel",
        desc: "Études en génie logiciel.",
        bullets: [],
      },
      "Computer Science degree": {
        subHeader: "Informatique (année d'échange)",
        desc: "Une année en tant qu'étudiant d'échange dans le cadre d'un programme de bourse internationale.",
        bullets: ["Sélectionné avec 32 autres étudiants parmi 10 000 candidats"],
      },
    },
  },

  ar: {
    roles: {
      "Astrolab Agency": "مطوّر باك-إند",
      "Dassault Systèmes": "متدرب هندسة برمجيات وعلوم بيانات",
      C4SAM: "مهندس باك-إند / DevOps (استشاري)",
      "CI-HUB": "مهندس باك-إند / ذكاء اصطناعي",
      ARSII: "متدرب تطبيقات الجوال",
      Capgemini: "مساعد استشاري",
      "Proxym-group": "متدرب تطوير ويب",
      "UW-Stout": "متدرب بحث علمي",
      "Microsoft Issatso Club": "رئيس النادي",
      "CyberTrace Club": "عضو فريق التطوير",
    },
    descs: {
      "Astrolab Agency": "أشارك في دورة تطوير حلول برمجية باستخدام NestJS.",
      "Dassault Systèmes": "مسؤول عن تنفيذ حل لاستيعاب السجلات وتحليلها باستخدام Java وPython وGrafana.",
      C4SAM: "مسؤول عن تطوير وصيانة منتج لتكامل أدوات DevSecOps.",
      "CI-HUB": "مسؤول عن تطوير وصيانة مشاريع الباك-إند والذكاء الاصطناعي للشركة.",
      ARSII: "شاركت في تصميم ونمذجة وتنفيذ ونشر تطبيق جوال متعدد المنصات.",
      Capgemini: "ضمن برنامج مجتمع المهندسين المعماريين، تعلّمت واختبرت أدوات DevOps بإشراف مهندس معماري في الشركة.",
      "Proxym-group": "نفّذت مفهوم maker-checker في تطبيق ويب مخصص للخدمات المالية باستخدام ‎.NET وReact.",
      "UW-Stout": "عملت مع مشرفي على قواعد بيانات NoSQL ومقارنة حالات استخدام مختلفة، وقدّمت النتائج في يوم البحث العلمي.",
      "Microsoft Issatso Club": "قدت النادي وطوّرته عبر أدوار ومسؤوليات متعددة، وعضو نشط منذ تأسيسه في 2019.",
      "CyberTrace Club": "شاركت في تطوير تطبيق ويب للنادي كمطوّر باك-إند.",
    },
    edu: {
      "Integrated Preparatory Cycle": {
        subHeader: "المرحلة التحضيرية المندمجة",
        desc: "درست مواد في الرياضيات والفيزياء وعلوم الحاسوب.",
        bullets: ["الأول على دفعتي"],
      },
      "Software Engineering degree": {
        subHeader: "شهادة هندسة البرمجيات",
        desc: "درست هندسة البرمجيات.",
        bullets: [],
      },
      "Computer Science degree": {
        subHeader: "علوم الحاسوب (سنة تبادل)",
        desc: "سنة كطالب تبادل ضمن برنامج منحة دولية.",
        bullets: ["اختير مع 32 طالبًا من بين 10 آلاف مرشح"],
      },
    },
  },
};
